import { ForbiddenErrorName } from '../constants/errorName';

export class ForbiddenError extends Error {
  constructor(message: string) {
    super(message);
    this.name = ForbiddenErrorName;
  }
}
